module.exports = __webpack_public_path__ + "static/media/about-shape3.75874451.png";